/**
 * Lazy Load Background Images
 */
const lazyLoadBackground = () => {
  $('[data-lazy-background]').each(function () {
    if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
      $(this).css('background-image', `url(${$(this).data('lazy-background')})`);
      $(this).removeAttr('data-lazy-background');
    }
  });
};

/**
 * Lazy Load Images
 */
const lazyLoadImages = () => {
  $('[data-lazy-img]').each(function () {
    if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
      $(this).attr('src', $(this).data('lazy-img'));
      $(this).removeAttr('data-lazy-img');
    }
  });
};

/**
 * Lazy Load Links
 */
const lazyLoadLinks = () => {
  $('[data-lazy-link]').each(function () {
    $(this).attr('href', $(this).data('lazy-link'));
  });
};

/**
 * Lazy Load Scripts
 */
const lazyLoadScripts = () => {
  $('[data-lazy-script]').each(function () {
    $(this).attr('src', $(this).data('lazy-script'));
  });
};

/**
 * Initialize lazy loading
 */
const init = () => {
  $(window).on('load resize scroll', () => {
    lazyLoadBackground();
    lazyLoadImages();
  });

  $(window).on('load', () => {
    lazyLoadLinks();
    lazyLoadScripts();
  });
};

export default { init };
